/** 
* This ES6(ECMAScript) function getQueryStringParameters takes url 
* as parmater and returns
* parameters name and value in JSON key value format 
* @parameter {String} url 
* (if url is not passed it takes the current url from window.location.href) 
* 
**/
const getQueryStringParameters = (url) => {
	let query;
	if (url) {
		if (url.split('?').length > 0) {
			query = url.split('?')[1];
		}
	} else {
		// url = window.location.href;
		query = window.location.search.substring(1);
	}
	return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce((params, param) => {
		let [ key, value ] = param.split('=');
		params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
		return params;
	}, {});
};

const getLastUrlSegment = (url) => {
	if (url) {
		return url.split('?')[0].split('/').filter((i) => i !== '').slice(-1)[0];
	} else {
		return window.location.pathname.split('?')[0].split('/').filter((i) => i !== '').slice(-1)[0];
	}
};

const getUrlHash = () => window.location.hash.substring(1);

const getDate = (days = 0) => {
	let date = new Date();
	date.setDate(date.getDate() + days);
	let dd = String(date.getDate()).padStart(2, '0');
	let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
	let yyyy = date.getFullYear();
	return yyyy + '-' + mm + '-' + dd;
};

const scroll = (id) => {
	let to = document.getElementById(id);
	// let element = document.scrollingElement || document.documentElement;
	// let rect = to.getBoundingClientRect();
	VueScrollTo.setDefaults({
		container: 'body',
		duration: 600,
		easing: 'ease',
		offset: -30,
		force: true,
		cancelable: true,
		onStart: false,
		onDone: false,
		onCancel: false,
		x: false,
		y: true
	});
	VueScrollTo.scrollTo(to);
};
